"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Swatch = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledSwatch = _interopRequireDefault(require("./styled-swatch"));
var _excluded = ["dataTestId", "imageSrc", "colour", "className"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  imageSrc: _propTypes["default"].string,
  colour: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['small', 'medium', 'large']), _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string,
    xl: _propTypes["default"].string,
    xxl: _propTypes["default"].string
  })])
};
var defaultProps = {
  className: undefined,
  dataTestId: null,
  imageSrc: null,
  colour: null,
  size: 'medium'
};
var Swatch = exports.Swatch = forwardRef(function (_ref, ref) {
  var dataTestId = _ref.dataTestId,
    imageSrc = _ref.imageSrc,
    colour = _ref.colour,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledSwatch["default"], _extends({
    className: className,
    "data-testid": dataTestId,
    imageSrc: imageSrc,
    colour: colour,
    ref: ref
  }, props));
});
Swatch.propTypes = propTypes;
Swatch.defaultProps = defaultProps;
var _default = exports["default"] = Swatch;